import styled from "styled-components";
import {Flex} from "./flex";
import {FlexCol} from "./flex-col";

export const FlexColHorCenter = styled(FlexCol)`
    flex-direction: column;
    align-items: center;
`;
